import React from 'react'
import PdaTitle from '../../../component/common/PdaTitle'
import LogoDark from '../../../component/common/LogoDark'
import { PdaMenuItem } from '../../../types/common'
import MenuLink from '../../../component/common/MenuLink'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const InventoryMenu = () => {
    const { t } = useTranslation()
    const menus: PdaMenuItem[] = [
        {
            name: t(tokens.inventory.slow_moving_inventory_location),
            uri: '/sluggish-inventory-location',
        },
        {
            name: t(tokens.inventory.scheduled_disposal_product_location),
            uri: '/abrogation-expected-location',
        },
        {
            name: t(tokens.inventory.unused_location),
            uri: '/unused-location',
        },
        {
            name: t(tokens.inventory.receiving_zone_location),
            uri: '/inbound-location',
        },
        {
            name: t(tokens.inventory.picking_zone_location),
            uri: '/picking-location',
        },
        {
            name: t(tokens.inventory.takeback_zone_location),
            uri: '/takeback-location',
        },
        {
            name: t(tokens.inventory.return_zone_location),
            uri: '/return-location',
        },
    ]

    return (
        <>
            <MenuLink items={menus} color="" />
        </>
    )
}

export default InventoryMenu
